/**
 * AI Analyst Page
 * 
 * Main page for AI Trade Analyst feature with:
 * - Split layout: Insights (left) + Chat (right) on desktop
 * - Stacked layout on mobile
 * - Framer Motion animations
 */

import React from 'react';
import { motion } from 'framer-motion';
import { InsightsPanel } from '../features/ai-analyst/components/InsightsPanel';
import { AIChat } from '../features/ai-analyst/components/AIChat';

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const panelVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 30 }
  }
};

export function AIAnalystPage() {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="min-h-[calc(100vh-200px)]"
    >
      {/* Page Header */}
      <motion.div variants={panelVariants} className="mb-6">
        <h1 className="text-2xl font-medium text-gray-900 dark:text-white">
          AI Trade Analyst
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Get AI-powered insights and ask questions about your trading performance
        </p>
      </motion.div>

      {/* Split Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Insights Panel */}
        <motion.div
          variants={panelVariants}
          className="bg-white dark:bg-dark-card rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-5 order-2 lg:order-1"
        >
          <InsightsPanel />
        </motion.div>

        {/* Chat Panel */}
        <motion.div
          variants={panelVariants}
          className="bg-white dark:bg-dark-card rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 overflow-hidden h-[500px] lg:h-[600px] order-1 lg:order-2"
        >
          <AIChat />
        </motion.div>
      </div>
    </motion.div>
  );
}

export default AIAnalystPage;

